import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IconComponent } from "../icon/icon.component";
import { prefixClass } from '../../../../core/constants/constants';

@Component({
    selector: 'app-button',
    standalone: true,
    imports: [CommonModule, IconComponent],
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    host: {
        '[class.disabled]': 'disabled',
        '[style.display]': '"block"',
        '[style.width]': 'fullWidth ? "100%" : "auto"'
    }
})
export class ButtonComponent {
    prefixClass: string = prefixClass;
    @Input() label: string = '';
    @Input() disabled: boolean = false;
    @Input() width: string = '145';
    @Input() fullWidth: boolean = false;
    @Input() loading: boolean = false;
    @Input() icon: boolean = false;
    @Input() iconName: string = '';
    @Input() variant: 'outlined' | 'filled' | 'text' = 'filled';
    constructor() {
    }
}